var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 0.659735L3.55556 0.659668L4.18409 1.28821L1.77778 3.69452V11.847L4.18409 14.2534L3.55556 14.8819H2.40625L0 12.5834V2.95814L2.40625 0.659735Z",
    fill: "#824BB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85071 3.41528H13.1476V4.84639H8.54315V7.04906H12.7867V8.45528H8.54315V10.6953H13.1476V12.1264H6.85071V3.41528Z",
    fill: "#B163FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3931 3.41528H20.8562L22.1878 4.75928V7.80817L20.8438 9.16462H17.0856V12.1264H15.3931V3.41528ZM20.0847 7.74595L20.5203 7.31039V5.26951L20.0847 4.83395H17.0856V7.74595H20.0847Z",
    fill: "#B163FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4961 3.41528H26.1885V12.1264H24.4961V3.41528Z",
    fill: "#B163FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7442 10.6953V4.84639L30.1753 3.41528H34.4313L35.8375 4.82151V6.15306H34.1451V5.44373L33.5602 4.85884H31.0713L30.4366 5.49351V10.0482L31.0713 10.6828H33.5602L34.1451 10.098V9.38862H35.8375V10.7202L34.4313 12.1264H30.1753L28.7442 10.6953Z",
    fill: "#B163FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2821 0.659735L39.1328 0.659668L38.5043 1.28821L40.9106 3.69452V11.847L38.5043 14.2534L39.1328 14.8819H40.2821L42.6884 12.5834V2.95814L40.2821 0.659735Z",
    fill: "#824BB9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/epic.1831f7676e2941779282bed527008565.svg";
export { ForwardRef as ReactComponent };